export default __webpack_public_path__ + "static/media/arrow_down.b5eceb09.svg";